import { render, staticRenderFns } from "./ChatEmojisDropdown.vue?vue&type=template&id=f2de48fa&scoped=true"
import script from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
export * from "./ChatEmojisDropdown.vue?vue&type=script&lang=js"
import style0 from "./ChatEmojisDropdown.vue?vue&type=style&index=0&id=f2de48fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2de48fa",
  null
  
)

export default component.exports